import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import BillingPage from './BillingPage.js';

export default WithGASetup(BillingPage, AuthContext);
